var map = {
	"./dashboard.svg": 9037,
	"./example.svg": 93862,
	"./eye-open.svg": 12540,
	"./eye.svg": 94082,
	"./form.svg": 61551,
	"./link.svg": 56229,
	"./nested.svg": 98588,
	"./password.svg": 31681,
	"./table.svg": 629,
	"./tree.svg": 94998,
	"./user.svg": 82383
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87886;